import(/* webpackMode: "eager", webpackExports: ["default"] */ "E:\\AjayWork\\Orange_Tiger_Nextjs\\src\\app\\orange-tiger-offers\\OrangeTigerOffersClient.js");
